import { SET_SITES, REMOVE_SITE } from '../sites';
import { UPDATE_LAYOUT, COPY_LAYOUT, RESET_LAYOUT, LAYOUT_SAVED } from './actions';

const initialState = {
  originalLayouts: {},
  layouts: {},
  updatedLayouts: [],
  isImportingLayout: false,
};

const defaultLayout = { pages: [], type: 'pt' };

const getLatestLayout = (layouts) =>
  layouts.length > 0
    ? layouts.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]
    : { ...defaultLayout };

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SITES: {
      const { sites } = action;
      return {
        ...state,
        layouts: sites.reduce((acc, { id, layouts = [] }) => {
          acc[id] = getLatestLayout(layouts);
          return acc;
        }, {}),
        originalLayouts: sites.reduce((acc, { id, layouts = [] }) => {
          acc[id] = getLatestLayout(layouts);
          return acc;
        }, {}),
      };
    }
    case UPDATE_LAYOUT: {
      const { siteId, layout, isImportingLayout } = action;
      const { layouts, updatedLayouts } = state;

      return {
        ...state,
        layouts: { ...layouts, [siteId]: layout },
        updatedLayouts: [...updatedLayouts, siteId],
        isImportingLayout,
      };
    }
    case COPY_LAYOUT: {
      const { siteId, layout } = action;
      const { layouts, updatedLayouts } = state;
      return {
        ...state,
        layouts: { ...layouts, [siteId]: layout },
        updatedLayouts: [...updatedLayouts, siteId],
      };
    }
    case RESET_LAYOUT: {
      const { siteId } = action;
      const { layouts, updatedLayouts, originalLayouts } = state;

      return {
        ...state,
        layouts: { ...layouts, [siteId]: { ...originalLayouts[siteId] } },
        updatedLayouts: updatedLayouts.filter((id) => id !== siteId),
        isImportingLayout: false,
      };
    }
    case LAYOUT_SAVED: {
      const { siteId, layout } = action;
      const { layouts, updatedLayouts, originalLayouts } = state;

      return {
        ...state,
        originalLayouts: { ...originalLayouts, [siteId]: layout },
        layouts: { ...layouts, [siteId]: layout },
        updatedLayouts: updatedLayouts.filter((id) => id !== siteId),
        isImportingLayout: false,
      };
    }
    case REMOVE_SITE: {
      const { siteId } = action;
      const { layouts, updatedLayouts, originalLayouts } = state;
      const newLayouts = { ...layouts };
      const newOriginalLayouts = { ...originalLayouts };
      delete newLayouts[siteId];
      delete newOriginalLayouts[siteId];

      return {
        ...state,
        layouts: newLayouts,
        originalLayouts: newOriginalLayouts,
        updatedLayouts: updatedLayouts.filter((id) => id !== siteId),
        isImportingLayout: false,
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
